import moment from "moment";
import { Component } from "react";


export default class PersonaFisica extends Component {




    render() {
        let datos = this.props.DatosPersonaFisica;
        let Titulo = this.props.Titulo;
        return (
            <div>

                <div className="card shadow mb-4">
                    <div className="card-header">
                        <h6 className="m-0 font-weight-bold text-primary">{Titulo ?? "Datos de la Persona"}</h6>
                    </div>
                    <div className="card-body text-gray-800">
                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="identificacion" id="lblIdentificacion" className="col-form-label">Identificación</label>
                                <input type="text" name="identificacion" id="identificacion" value={datos.identificacionPrincipal.codigo} className="form-control" readOnly />
                                <input type="hidden" name="HiddenIdentificacion" id="HiddenIdentificacion" value={datos.identificacionPrincipal.codigo} readOnly />
                            </div>
                            <div className="form-group  col-md-6">
                                <label htmlFor="tipoPersona" className="col-form-label">Tipo Persona </label>
                                <input type="text" name="tipoPersona" id="tipoPersona" value={datos.identificacionPrincipal.tipoPersona.nombre} className="form-control" readOnly />
                                <input type="hidden" name="HiddenClasePersona" id="HiddenClasePersona" value={datos.identificacionPrincipal.tipoPersona.clase} readOnly />
                                <input type="hidden" name="HiddenIdPersona" id="HiddenIdPersona" value={datos.identificacionPrincipal.tipoPersona.codigo} readOnly />

                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label id="lblNombreORazonSocial" htmlFor="nombrePersonaFisica" className="col-form-label">Nombre</label>
                                <input type="text" name="nombrePersonaFisica" id="nombrePersonaFisica" value={datos.nombreORazonSocial} className="form-control" readOnly />
                            </div>

                            <div className="form-group col-md-4">
                                <label id="lblPrimerApellido" htmlFor="primerApellido" className="col-form-label">Primer Apellido</label>
                                <input type="text" name="primerApellido" id="primerApellido" value={datos.primerApellido} className="form-control" readOnly />
                            </div>

                            <div className=" form-group col-md-4">
                                <label id="lblSegundoApellido" htmlFor="segundoApellido" className="col-form-label">Segundo Apellido</label>
                                <input type="text" name="segundoApellido" id="segundoApellido" value={datos.segundoApellido ?? ""} className="form-control" readOnly />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group col-md-6">
                                <label id="lblPaisNacimiento" htmlFor="paisNacimiento" className="col-form-label">País Nacimiento</label>
                                <input type="text" name="paisNacimiento" id="paisNacimiento" value={datos.paisRegistroONacimiento?.nombrePais??""} className="form-control" readOnly />
                            </div>
                            <div className="form-group col-md-6">
                                <label id="lblFechaNacimiento" htmlFor="fechaNacimiento" className="col-form-label">Fecha Nacimiento</label>
                                <input type="datetime" name="fechaNacimiento" id="fechaNacimiento" value={datos.fechaConstitucionONacimiento !== null ? moment(datos.fechaConstitucionONacimiento).format("DD/MM/YYYY") : ""} className="form-control" readOnly />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}